module.exports = __webpack_public_path__ + "media/images/picture_book-b9c0fe20eba1b33f64ebfa3fd47caf9d.png";